import { Cake, Confetti } from "@phosphor-icons/react";

const fmt = (d) => new Date(d + "T00:00:00").toLocaleDateString("en-IN", { day: "numeric", month: "short" });

const EventList = ({ items, empty, kind }) => (
  <div className="divide-y divide-stone-100">
    {items.length === 0 && <p className="py-6 text-center text-sm text-stone-400">{empty}</p>}
    {items.map((e, i) => (
      <div key={`${e.name}-${e.date}`} className="py-2.5 flex items-center justify-between gap-3" data-testid={`${kind}-row-${i}`}>
        <div>
          <div className="text-sm font-semibold">{e.name}</div>
          <div className="text-xs text-stone-500">{e.department}{kind === "anniversary" ? ` · ${e.years} year${e.years > 1 ? "s" : ""}` : ""}</div>
        </div>
        <span className="text-sm font-bold text-primary tabular-nums shrink-0">{fmt(e.date)}</span>
      </div>
    ))}
  </div>
);

export const CelebrationsBoard = ({ birthdays = [], anniversaries = [] }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="celebrations-board">
    <div className="bg-white border border-stone-200 rounded-lg p-6">
      <h3 className="font-heading font-bold mb-3 flex items-center gap-2" data-testid="birthdays-heading">
        <Cake size={20} weight="duotone" className="text-primary" /> Upcoming birthdays
      </h3>
      <EventList items={birthdays} empty="No birthdays in the next 30 days." kind="birthday" />
    </div>
    <div className="bg-white border border-stone-200 rounded-lg p-6">
      <h3 className="font-heading font-bold mb-3 flex items-center gap-2" data-testid="anniversaries-heading">
        <Confetti size={20} weight="duotone" className="text-secondary" /> Work anniversaries
      </h3>
      <EventList items={anniversaries} empty="No anniversaries in the next 30 days." kind="anniversary" />
    </div>
  </div>
);
